<template>
  <div class="body_box">
    <div class="note_box">
      <div class="introduce_box" :style="bgc">
        <div class="introduce_left">
          <span class="top">您一共有{{ noteNums.num }}个{{ names }}</span>
          <span class="bottom">在{{ noteNums.bookNum }}本书上</span>
        </div>
        <div class="introduce_right" v-if="type == 'note'">
          <img src="../../../assets/icon/greenbigbj.png" alt="" />
        </div>
        <div class="introduce_right" v-if="type == 'bookmark'">
          <img src="../../../assets/icon/bigsq.png" alt="" />
        </div>
        <div class="introduce_right" v-if="type == 'lineation'">
          <img src="../../../assets/icon/huaxian.png" alt="" />
        </div>
      </div>
      <div class="note_item" v-for="(item, index) in mynotesList" :key="index">
        <div class="title_box">
          <div class="left_img">
            <img :src="item.picUrl" alt="" />
          </div>
          <div class="right">
            <span class="bookname">
              {{ item.bookName }}
            </span>
            <div class="num_box">
              <span class="nums"> {{ item.noteNum }}个{{ names }}</span>
              <img
                src="../../../assets/icon/reddelete.png"
                alt=""
                @click="allBookDelete(item.id)"
              />
            </div>
          </div>
        </div>
        <div class="notes">
          <div
            class="notes_demo"
            v-for="(items, indexs) in item.noteList"
            :key="indexs"
          >
            <div class="demo_img" v-if="type == 'note'">
              <img src="../../../assets/icon/greenbj.png" alt="" />
            </div>
            <div class="demo_img_bookmark" v-if="type == 'bookmark'">
              <img src="../../../assets/icon/sq.png" alt="" />
            </div>
            <div class="demo_img_line" v-if="type == 'lineation'">
              <img src="../../../assets/icon/hx.png" alt="" />
            </div>
            <div class="nodeitem_box">
              <div class="note_title" v-if="type != 'lineation'">
                {{ items.noteContent }}
              </div>
              <div class="note_title" v-else>
                {{ items.text }}
              </div>
              <div class="nodecenter_box" v-if="type == 'note'">
                {{ items.originalText }}
              </div>
              <div class="time_box">
                <span class="times"> {{ items.createTime }}</span>
                <div class="edit_box">
                  <!-- <div class="left">
                    <img src="../../../assets/icon/edit.png" alt="" />
                    修改
                  </div> -->
                  <div class="right" @click="deleteNoteitem(items.id)">
                    <img src="../../../assets/icon/reddelete.png" alt="" />
                    删除
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="more"
          @click="seeMorefn(item, index)"
          v-if="item.pageNum * item.pageSize < item.total"
        >
          查看更多<img src="../../../assets/icon/xiala.png" alt="" />
        </div>
      </div>
    </div>
    <div class="pages_box">
      <pages
        :total="total"
        :pageNum="pageNum"
        :pageSize="pageSize"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pages>
    </div>
    <noData v-if="total == 0"></noData>
  </div>
</template>

<script lang="js">
import {
  queryMyNoteList,
  queryMyNoteInfo,
  queryMyNoteNumAndBookNum,
  delByBookId,
  delById,
} from "@/api/user/learning.js";
import noData from "@/components/noData.vue";
import pages from "@/components/pages.vue";
export default {
  components: { noData, pages },
  data() {
    return {
      names: "",
      type: "note",
      pageNum: 1,
      pageSize: 10,
      mynotesList: [],
      total: 0,
      noteNums: {},
      bgc: "",
    };
  },
  watch: {
    $route(route) {
      this.type = this.$route.query.type;
      // console.log("this.$route.query.type", this.$route.query.type);
      if (this.type == "note") {
        this.names = "笔记";
        this.bgc =
          "background: linear-gradient(-25deg,rgba(127, 221, 140, 0.88), rgba(181, 255, 206, 0.88))";
      } else if (this.type == "bookmark") {
        this.names = "书签";
        this.bgc =
          "background: linear-gradient(-25deg, rgba(255,195,139,0.88), rgba(255,237,190,0.88));";
      } else if (this.type == "lineation") {
        this.names = "划线";
        this.bgc =
          "background: linear-gradient(-25deg, rgba(78,144,243,0.88), rgba(207,226,255,0.88));";
      }
      this.pageNum = 1;
      this.mynotesList = [];
      this.getMyNotes();
      this.getNoteNums();
    },
  },
  created() {
    this.type = this.$route.query.type;
    // console.log("this.$route.query.type", this.$route.query.type);
    if (this.type == "note") {
      this.names = "笔记";
      this.bgc =
        "background: linear-gradient(-25deg,rgba(127, 221, 140, 0.88), rgba(181, 255, 206, 0.88))";
    } else if (this.type == "bookmark") {
      this.names = "书签";
      this.bgc =
        "background: linear-gradient(-25deg, rgba(255,195,139,0.88), rgba(255,237,190,0.88));";
    } else if (this.type == "lineation") {
      this.bgc =
        "background: linear-gradient(-25deg, rgba(78,144,243,0.88), rgba(207,226,255,0.88));";
      this.names = "划线";
    }
    this.pageNum = 1;
    this.mynotesList = [];
    this.getMyNotes();
    this.getNoteNums();
  },
  // mounted() {

  //   this.getMyNotes();
  //   this.getNoteNums();
  // },
  methods: {
    // 获取笔记列表
    getMyNotes() {
      // {
      //   type: this.type,
      //   pageNum: this.pageNum,
      //   pageSize: this.pageSize,
      // }
      queryMyNoteList(this.type, this.pageNum, this.pageSize).then((res) => {
        console.log(res);
        let list = res.rows;
        list.map((item, index) => {
          this.$set(item, "noteList", []);
          this.$set(item, "pageNum", 1);
          this.$set(item, "pageSize", 3);
          this.$set(item, "total", 0);
          let data = {
            goodsId: item.id,
            pageNum: item.pageNum,
            pageSize: item.pageSize,
            type: this.type,
          };
          this.getBookNotes(data, index + (this.pageNum - 1) * this.pageSize);
          console.log("this.mynotesList", this.mynotesList);
        });
        this.mynotesList = this.mynotesList.concat(list);
        this.total = res.total;
      });
    },
    getBookNotes(data, index) {
      queryMyNoteInfo(data).then((res) => {
        this.mynotesList[index].noteList = this.mynotesList[
          index
        ].noteList.concat(res.rows);
        this.mynotesList[index].total = res.total;
      });
    },
    getNoteNums() {
      queryMyNoteNumAndBookNum(this.type).then((res) => {
        this.noteNums = res.data;
      });
    },
    // 删除整本书
    allBookDelete(id) {
      console.log(id, "id");
      delByBookId({
        ids: [id],
        type: this.type,
      }).then((res) => {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.pageNum = 1;
        this.mynotesList = [];
        this.getMyNotes();
        this.getNoteNums();
      });
    },
    // 删除笔记
    deleteNoteitem(id) {
      delById({
        ids: [id],
      }).then((res) => {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.pageNum = 1;
        this.mynotesList = [];
        this.getMyNotes();
        this.getNoteNums();
      });
    },
    // 查看更多
    seeMorefn(item, index) {
      console.log("item", item);
      if (item.pageNum * item.pageSize < item.total) {
        item.pageSize = 1000;
        let data = {
          goodsId: item.id,
          type: this.type,
          pageNum: item.pageNum,
          pageSize: item.pageSize,
        };
        // item.pageNum += 1;
        item.noteList = [];
        this.getBookNotes(data, index);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.mynotesList = [];
      this.getMyNotes();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.mynotesList = [];
      this.getMyNotes();
    },
  },
};
</script>

<style lang="scss" scoped>
.pages_box {
  display: flex;
  justify-content: flex-end;
  padding-right: 41px;
  padding-bottom: 41px;
}
.body_box {
  margin: auto;
  margin-left: 15px;
  margin-top: 20px;
}
.note_box {
  .introduce_box {
    width: 1041px;
    height: 77px;

    border: 1px solid #f2f2f2;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    .introduce_left {
      margin-left: 37px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .top {
        font-size: 20px;
        font-family: PingFang SC;
        color: #ffffff;
      }
      .bottom {
        font-size: 17px;
        font-family: PingFang SC;
        color: #ffffff;
      }
    }
    .introduce_right {
      margin-top: 8px;
      margin-right: 36px;
      width: 60px;
      height: 62px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .note_item {
    margin-top: 11px;
    box-sizing: border-box;
    width: 1041px;
    padding: 14px 27px 10px 15px;
    background: #ffffff;
    border: 1px solid #f2f2f2;
    border-radius: 6px;
    .title_box {
      display: flex;
      .left_img {
        width: 89px;
        height: 89px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        flex: 1;
        margin-left: 19px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .bookname {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        }
        .num_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .nums {
            font-size: 17px;
            font-family: PingFang SC;
            color: #333333;
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
    .notes {
      margin-top: 24px;
      .notes_demo {
        margin-bottom: 10px;
        display: flex;
        .demo_img {
          flex-shrink: 0;
          width: 18px;
          height: 18px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .demo_img_line {
          flex-shrink: 0;
          width: 12px;
          height: 18px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .demo_img_bookmark {
          flex-shrink: 0;
          width: 13px;
          height: 17px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .nodeitem_box {
        border-bottom: 1px solid #f2f2f2;
        padding-bottom: 17px;
        flex: 1;
        margin-left: 15px;
        .note_title {
          font-size: 14px;
          font-family: PingFang SC;
          color: #333333;
          line-height: 17px;
        }
        .nodecenter_box {
          margin: 16px 0 0 6px;
          border-left: 2px solid #f2f2f2;
          padding-left: 17px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
        }
        .time_box {
          margin-top: 17px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .times {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #7c7c7c;
          }
          .edit_box {
            display: flex;
            align-items: center;
            .left {
              cursor: pointer;
              display: flex;
              align-items: center;
              font-size: 12px;
              font-family: PingFang SC;
              color: #3466a0;
              img {
                margin-right: 6px;
                width: 11px;
                height: 11px;
              }
            }
            .right {
              cursor: pointer;
              margin-left: 17px;
              display: flex;
              align-items: center;
              font-size: 12px;
              font-family: PingFang SC;
              color: #ed0808;
              img {
                margin-right: 6px;
                width: 11px;
                height: 11px;
              }
            }
          }
        }
      }
    }
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 14px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      img {
        margin-left: 6px;
        width: 12px;
        height: 6px;
      }
    }
  }
}
</style>
